// src/http/runtimeClient.ts
import type { AxiosInstance } from "axios";

export enum ClientType {
  ControlPlane = "ControlPlane",
  Auth = "Auth",
}

const _clients = new Map<ClientType, AxiosInstance>();

export function setClient(type: ClientType, client: AxiosInstance) {
  _clients.set(type, client);
}

export function getClient(type: ClientType): AxiosInstance {
  const client = _clients.get(type);
  if (!client) throw new Error("Axios client not initialized yet");
  return client;
}
